module.exports = __webpack_public_path__ + "static/viveport-1a29ac42dc46db562b052581ab8c8fbc.png";